import { currentUser } from "./session";
export function currentUserHasRole(role) {
    var _a, _b;
    return (_b = (_a = currentUser().roles) === null || _a === void 0 ? void 0 : _a.includes(role)) !== null && _b !== void 0 ? _b : false;
}
export function currentUserHasAnyRole(roles) {
    return roles.some((role) => currentUserHasRole(role));
}
